exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".header-2ef058fe{width:100%;height:300px;position:relative;text-align:center}.header-2ef058fe>.text-41053130{color:#fff;height:100%;position:absolute;top:0px;left:50%;transform:translate(-50%, 0);display:flex;flex-direction:column;justify-content:center;align-items:center}.header-2ef058fe>.text-41053130>h2{color:#fff}.header-2ef058fe>.text-41053130>h1{margin-bottom:0px}.img-00056298{width:100%;height:300px;object-fit:cover}\n", ""]);

// Exports
exports.locals = {
	"header": "header-2ef058fe",
	"text": "text-41053130",
	"img": "img-00056298"
};